import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./style.css";
import { keycloak, onLogout, onLoadUser, onLogin } from "./utils/keycloak";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://4a4bac03c6f1ffaee709d7cb803d967f@o4508092667002880.ingest.de.sentry.io/4509763381690448",
  sendDefaultPii: true,
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "system",
      isNameRequired: true,
      isEmailRequired: true,
    }),
  ],
});

console.log("process");
console.log(process.env.REACT_APP_KEYCLOAK);

const Main = () => {
  const [keycloakInitialized, setKeycloakInitialized] = useState(false);

  useEffect(() => {
    keycloak
      .init({ onLoad: "check-sso", checkLoginIframe: false })
      .then((authenticated) => {
        if (authenticated) {
          localStorage.setItem("kc_token", keycloak.token);
          onLoadUser();
        }
        setKeycloakInitialized(true);
      });
  }, []);

  if (!keycloakInitialized) return <></>;

  return (
    <React.StrictMode>
      <BrowserRouter>
        <App onLogout={onLogout} token={localStorage.getItem("kc_token")} />
      </BrowserRouter>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Main />);
